<template>
  <div class="About">
    <img v-lazy="icon_src" height="150" alt="kkimu">
    <h3>Profile</h3>
    <p>{{name}}</p>
    <p>{{description}}</p>
    <h3>Social</h3>
    <ul>
      <li>
        <i class="fab fa-twitter fa-gray"></i>
        <a href="https://twitter.com/_kkimu" target="_blank">@_kkimu</a>
      </li>
      <li>
        <i class="fab fa-github fa-gray"></i>
        <a href="https://github.com/kkimu" target="_blank">id: kkimu</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'About',
  data: () => {
    const icon_src = require('../assets/icon.png');
    return {
      name: '木邑 和馬 / Kazuma Kimura',
      description: 'ソフトウェアエンジニア / プロダクトオーナー',
      icon_src,
    };
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0 10px;
  line-height: 2;
}
.fab {
  margin-right: 5px;
  font-size: 1.1rem;
}
.fa-gray:before {
  color: #808080 ;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue